import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ASSETS } from "@/lib/brand";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-navy pt-32 pb-20 px-6 md:px-12 relative">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 grain"></div>
      </div>

      <div className="relative max-w-md mx-auto">
        <Link to="/" className="flex items-center gap-3 mb-12">
          <img src={ASSETS.monogram} alt="MS" className="h-10 w-10 rounded-sm border hairline" />
          <div>
            <p className="font-overline text-silver-muted">Office of</p>
            <p className="font-display text-lg text-silver">Miguel Santana</p>
          </div>
        </Link>

        <p className="font-overline text-champagne mb-4">— Admin</p>
        <h1 className="font-display text-4xl md:text-5xl text-silver tracking-tighter leading-[1.05]">
          Sign in to the<br />
          <span className="italic font-light">Control Room.</span>
        </h1>

        <form onSubmit={submit} className="mt-12 space-y-8" data-testid="admin-login-form">
          <div>
            <label className="font-overline text-silver-muted block mb-1">Email</label>
            <input
              data-testid="admin-login-email"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-editorial"
              placeholder="admin@iammiguelsantana.com"
            />
          </div>
          <div>
            <label className="font-overline text-silver-muted block mb-1">Password</label>
            <input
              data-testid="admin-login-password"
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-editorial"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="font-body text-red-300 text-sm">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-editorial btn-editorial-filled w-full justify-center disabled:opacity-50"
          >
            {loading ? "Verifying…" : "Sign In"}
          </button>
        </form>

        <div className="mt-12 border-t hairline pt-6">
          <Link to="/" className="font-overline text-silver-muted hover:text-silver transition-colors">
            ← Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
